import React, { useEffect, useRef } from 'react';
import styles from './ChevronType1.module.scss';
import { twMerge } from 'tailwind-merge';
import { ArrowCouple, ArrowIcon } from '../../../Arrows';
import { isMobileDevice } from 'src/components/WidgetMaker/WidgetDnD/isMobileDevice';

export function ChevronType1({
  showArrows,
  showChevrons,
  handlePrevClick,
  handleNextClick,
  chevronAnimationTiming,
  arrowPosition,
  containerClass = '',
  showGradient = false,
  arrowStyle = {},
  ...props
}) {
  const progressContainerRef = useRef<any>(null);
  const progressElementsRef = useRef<any>({});
  const isMobile = isMobileDevice();

  useEffect(() => {
    if (props.isAutoPlayOn) {
      const progress = Object.values(progressElementsRef.current) as any;

      const playNext = (e?: any) => {
        const current = e && e.target;
        let next;

        if (current) {
          const currentIndex = progress.indexOf(current);
          if (currentIndex < progress.length) {
            next = progress[currentIndex + 1];
          }
          current.classList.remove(styles['active']);
          current.classList.add(styles['passed']);
        }

        if (!next) {
          progress.map((el) => {
            el.classList.remove(styles['active']);
            el.classList.remove(styles['passed']);
          });
          next = progress[props.currentActiveSlideIndex || 0];
        }
        next?.classList?.add(styles['active']);
      };

      if (progress?.length) {
        progress.map((el) => el.addEventListener('animationend', playNext, false));
        playNext();
      }

      return () => {
        if (progress?.length) {
          progress.map((el) => el.removeEventListener('animationend', playNext, false));
        }
      };
    }
  }, [props.currentActiveSlideIndex, props.isAutoPlayOn]);

  return (
    <div
      className={twMerge(
        'chevronType1Container tw-pointer-events-none',
        `tw-relative tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-px-[40px] ${showGradient ? '' : 'tw-py-[24px]'}`,
        containerClass
      )}
    >
      {showArrows && arrowPosition === 'center' && (
        <ArrowCouple
          isVisible={showArrows}
          handlePrevClick={handlePrevClick}
          handleNextClick={handleNextClick}
          imageProps={props}
          arrowType={props?.arrowType || 'v1'}
          containerClass={containerClass}
        />
      )}
      {showChevrons && (
        <div
          style={{background: showGradient ? 'linear-gradient(167.92deg, rgba(0, 0, 0, 0) 8.57%, rgba(0, 0, 0, 0.6) 90.96%)' : ''}}
          className={twMerge(
            styles['progress-container'],
            'tw-pointer-events-auto',
            'tw-mt-auto tw-gap-[6px]',
            showGradient ? `tw-justify-center tw-h-[30px] ${isMobile ? 'tw-mx-[-12px] tw-w-[100vw]' : 'tw-w-[680px] tw-mx-[-24px]'}` : ''
          )}
          ref={progressContainerRef}
        >
          {showArrows && arrowPosition === 'bottom' && (
            <ArrowIcon
              onClick={handlePrevClick}
              arrowDirection="left"
              arrowType={'v1'}
              imageProps={{
                ...props,
                className: 'tw-mr-[10px]',
              }}
            />
          )}
          {props.images.map((_, index) => {
            return (
              <div
                key={index}
                className={twMerge(
                  styles['progress'],
                  !props.isAutoPlayOn ? styles['isNotAnimatable'] : '',
                  showArrows && arrowPosition === 'bottom' && 'tw-top-[-2.5px]',
                  !props.isAutoPlayOn &&
                    (props.currentActiveSlideIndex === index ? styles['isActive'] : '')
                )}
                style={{ animationDuration: chevronAnimationTiming }}
                ref={(node) => (progressElementsRef.current[index] = node)}
              />
            );
          })}
          {showArrows && arrowPosition === 'bottom' && (
            <ArrowIcon
              onClick={handleNextClick}
              arrowDirection="right"
              arrowType={'v1'}
              imageProps={{
                ...props,
                className: 'tw-ml-[10px]',
              }}
            />
          )}
        </div>
      )}
    </div>
  );
}
